import Vue from 'vue';
import App from './App.vue';
import router from './routers';
import store from './stores';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Loading from 'vue-loading-overlay';
import Notifications from 'vue-notification';
import { ServerTable, ClientTable } from 'vue-tables-2';
import Treeselect from '@riophae/vue-treeselect';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMapbox from '@studiometa/vue-mapbox-gl';
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric';
import UploadImage from 'vue-upload-image';
import VueRandomColor from 'vue-randomcolor';
// import DatePick from 'vue-date-pick';
import Datepicker from 'vuejs-datepicker';

import './registerServiceWorker';
import '@/sass/main.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
// import 'vue-date-pick/dist/vueDatePick.css';

Vue.config.productionTip = false;

Vue.use(ServerTable);
Vue.use(VueRandomColor);
Vue.use(ClientTable);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notifications);
Vue.use(VueSweetalert2);
Vue.use(VueMapbox);
Vue.use(require('vue-moment'));

Vue.component('loading', Loading);
Vue.component('vue-treeselect', Treeselect);
Vue.component('date-pick', Datepicker);
Vue.component('vue-autonumeric', VueAutonumeric);
Vue.component('upload-image', UploadImage);

// const options = {
//     digitGroupSeparator: '.',
//     decimalCharacter: ',',
//     decimalCharacterAlternative: '.',
//     currencySymbol: '\u00a0€',
//     currencySymbolPlacement: 's',
//     roundingMethod: 'U',
//     minimumValue: '0'
// };

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');